import {
  PollProvider,
  useChatContext,
} from 'stream-chat-react'
import { ChatLocalMesage } from '@packages/chat'
import { PollCard } from './PollCard'

type PollProps = {
  message: ChatLocalMesage
  isThreadParent: boolean
}

export const Poll = ({ message, isThreadParent }: PollProps) => {
  const { client } = useChatContext()
  const pollId = message?.poll_id

  if (!pollId) return null

  const poll = client.polls.fromState(pollId)

  if (!poll) return null

  return (
    <PollProvider poll={poll}>
      <PollCard message={message} isThreadParent={isThreadParent} />
    </PollProvider>
  )
}

